/* eslint-disable no-undef */
import React from "react";
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import axios from "axios";
import { getCookie } from "../jwt/_helpers/cookie";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const AccountingModalConfirm = ({
  openModal,
  setToggleModal,
  title,
  dataModal,
  setRedirect,
  body,
  setError,
  submitFormCustom,
  rowId,
  setSuccess,
  apiURL,
  method = "POST"
}) => {
  const tokenAPI = getCookie("token");
  const { t } = useTranslation();

  const handleSubmit = () => {
    const options = {
      method: "POST",
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${tokenAPI}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    };

    if (method === "POST") {
      axios
        .post(`${API_URL}${apiURL}/`, dataModal, options)
        .then(res => {
          if(rowId) {
            let element = document.getElementById(rowId);
            ReactDOM.findDOMNode(element).classList.remove("text-danger");
            ReactDOM.findDOMNode(element).classList.remove("fa-times-circle");
            ReactDOM.findDOMNode(element).classList.add("text-success");
            ReactDOM.findDOMNode(element).classList.add("fa-check-circle");
          }
          if (setRedirect) {
            setToggleModal(false);
            setTimeout(() => setRedirect(true), 1000);
          } else {
            setToggleModal(false);
          }
        })
        .catch(err => {
          setError(true);
        });
    } else if (method === "PUT") {
      axios
        .put(`${API_URL}${apiURL}/`, dataModal, options)
        .then(res => {
          setSuccess(true);
          if (setRedirect) {
            setToggleModal(false);
            setTimeout(() => setRedirect(true), 1000);
          } else {
            setToggleModal(false);
          }
        })
        .catch(err => {
          setError(true);
        });
    }
  };
  return (
    <Modal isOpen={openModal} centered={true}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setToggleModal(false)}>
          {t("accounting.breakdown.view.table.modal.confirm.button.cancel")}
        </Button>
        <Button color="success" onClick={() => handleSubmit()}>
          {t("accounting.breakdown.view.table.modal.confirm.button.confirm")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AccountingModalConfirm;
